import 'css-chunksrc/client/pages/zonesPage/wbsPage/filters/styles.scss';export default {
  "filters": "_filters_1prwc_1",
  "resetButton": "_resetButton_1prwc_9",
  "label": "_label_1prwc_17",
  "section": "_section_1prwc_24"
};